!function(a) {
    if (a(".collection-sidebar")) History.Adapter.bind(window, "statechange", function() {
        var a = History.getState();
        if (!b.isSidebarAjaxClick) {
            b.sidebarParams();
            var c = b.sidebarCreateUrl();
            b.sidebarGetContent(c);
            b.reActivateSidebar();
        }
        b.isSidebarAjaxClick = false;
    });
    if (window.use_color_swatch) {
        a(".swatch :radio").change(function() {
            var b = a(this).closest(".swatch").attr("data-option-index");
            var c = a(this).val();
            a(this).closest("form").find(".single-option-selector").eq(b).val(c).trigger("change");
        });
        Shopify.optionsMap = {};
        Shopify.updateOptionsInSelector = function(b) {
            switch (b) {
              case 0:
                var c = "root";
                var d = a(".single-option-selector:eq(0)");
                break;

              case 1:
                var c = a(".single-option-selector:eq(0)").val();
                var d = a(".single-option-selector:eq(1)");
                break;

              case 2:
                var c = a(".single-option-selector:eq(0)").val();
                c += " / " + a(".single-option-selector:eq(1)").val();
                var d = a(".single-option-selector:eq(2)");
            }
            var e = d.val();
            d.empty();
            var f = Shopify.optionsMap[c];
            for (var g = 0; g < f.length; g++) {
                var h = f[g];
                var i = a("<option></option>").val(h).html(h);
                d.append(i);
            }
            a('.swatch[data-option-index="' + b + '"] .swatch-element').each(function() {
                if (a.inArray(a(this).attr("data-value"), f) !== -1) a(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked"); else a(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled");
            });
            if (a.inArray(e, f) !== -1) d.val(e);
            d.trigger("change");
        };
        Shopify.linkOptionSelectors = function(b) {
            for (var c = 0; c < b.variants.length; c++) {
                var d = b.variants[c];
                if (d.available) {
                    Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
                    Shopify.optionsMap["root"].push(d.option1);
                    Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
                    if (b.options.length > 1) {
                        var e = d.option1;
                        Shopify.optionsMap[e] = Shopify.optionsMap[e] || [];
                        Shopify.optionsMap[e].push(d.option2);
                        Shopify.optionsMap[e] = Shopify.uniq(Shopify.optionsMap[e]);
                    }
                    if (3 === b.options.length) {
                        var e = d.option1 + " / " + d.option2;
                        Shopify.optionsMap[e] = Shopify.optionsMap[e] || [];
                        Shopify.optionsMap[e].push(d.option3);
                        Shopify.optionsMap[e] = Shopify.uniq(Shopify.optionsMap[e]);
                    }
                }
            }
            Shopify.updateOptionsInSelector(0);
            if (b.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (3 === b.options.length) Shopify.updateOptionsInSelector(2);
            a(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (3 === b.options.length) Shopify.updateOptionsInSelector(2);
                return true;
            });
            a(".single-option-selector:eq(1)").change(function() {
                if (3 === b.options.length) Shopify.updateOptionsInSelector(2);
                return true;
            });
        };
    }
    a(document).ready(function() {
        b.init();
    });
    a(window).resize(function() {
        b.initMobileMenu();
        b.initResizeImage();
    });
    a(window).scroll(function() {
        if (a(this).scrollTop() > 200) a("#back-top").fadeIn(); else a("#back-top").fadeOut();
    });
    if (!a(".header-mobile").is(":visible")) a(document).on("click touchstart", function(c) {
        var d = a(".quick-view");
        var e = a("#dropdown-cart");
        var f = a("#cartToggle");
        var g = a("#email-modal .modal-window");
        var h = a(".nav-search");
        if (!d.is(c.target) && 0 === d.has(c.target).length && !e.is(c.target) && 0 === e.has(c.target).length && !f.is(c.target) && 0 === f.has(c.target).length && !g.is(c.target) && 0 === g.has(c.target).length && !h.is(c.target) && 0 === h.has(c.target).length) {
            b.closeQuickViewPopup();
            b.closeDropdownCart();
            b.closeEmailModalWindow();
            b.closeDropdownSearch();
        }
    });
    a(document).keyup(function(c) {
        if (27 == c.keyCode) {
            b.closeQuickViewPopup();
            b.closeDropdownCart();
            b.closeDropdownSearch();
            clearTimeout(b.ellaTimeout);
            if (a(".modal").is(":visible")) a(".modal").fadeOut(500);
        }
    });
    var b = {
        ellaTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {
            this.initResizeImage();
            this.initMobileMenu();
            this.initSidebar();
            this.initMobileSidebar();
            this.initScrollTop();
            this.initQuickView();
            this.initCloudzoom();
            this.initProductMoreview();
            this.initAddToCart();
            this.initModal();
            this.initProductAddToCart();
            this.initDropDownCart();
            this.initDropdownSearch();
            this.initToggleCollectionPanel();
            this.initWishlist();
            this.initProductWishlist();
            this.initRemoveWishlist();
            this.initInfiniteScrolling();
        },
        sidebarMapTagEvents: function() {
            a(".sidebar-tag a, .sidebar-tag label").click(function(c) {
                var d = [];
                if (Shopify.queryParams.constraint) d = Shopify.queryParams.constraint.split("+");
                if (!window.enable_sidebar_multiple_choice && !a(this).prev().is(":checked")) {
                    var e = a(this).parents(".sidebar-tag").find("input:checked");
                    if (e.length > 0) {
                        var f = e.val();
                        if (f) {
                            var g = d.indexOf(f);
                            if (g >= 0) d.splice(g, 1);
                        }
                    }
                }
                var f = a(this).prev().val();
                if (f) {
                    var g = d.indexOf(f);
                    if (g >= 0) d.splice(g, 1); else d.push(f);
                }
                if (d.length) Shopify.queryParams.constraint = d.join("+"); else delete Shopify.queryParams.constraint;
                b.sidebarAjaxClick();
                c.preventDefault();
            });
        },
        sidebarMapCategories: function() {
            a(".sidebar-links a").click(function(c) {
                if (!a(this).hasClass("active")) {
                    delete Shopify.queryParams.q;
                    b.sidebarAjaxClick(a(this).attr("href"));
                    a(".sidebar-links a.active").removeClass("active");
                    a(this).addClass("active");
                }
                c.preventDefault();
            });
        },
        sidebarMapView: function() {
            a(".view-mode a").click(function(c) {
                if (!a(this).hasClass("active")) {
                    var d = a(".filter-show > button span").text();
                    if (a(this).hasClass("list")) Shopify.queryParams.view = "list" + d; else Shopify.queryParams.view = d;
                    b.sidebarAjaxClick();
                    a(".view-mode a.active").removeClass("active");
                    a(this).addClass("active");
                }
                c.preventDefault();
            });
        },
        sidebarMapShow: function() {
            a(".filter-show a").click(function(c) {
                if (!a(this).parent().hasClass("active")) {
                    var d = a(this).attr("href");
                    var e = a(".view-mode a.active").attr("href");
                    if ("list" == e) Shopify.queryParams.view = "list" + d; else Shopify.queryParams.view = d;
                    b.sidebarAjaxClick();
                    a(".filter-show > button span").text(d);
                    a(".filter-show li.active").removeClass("active");
                    a(this).parent().addClass("active");
                }
                c.preventDefault();
            });
        },
        sidebarInitToggle: function() {
            if (a(".sidebar-tag").length > 0) a(".sidebar-tag .widget-title span").click(function() {
                var b = a(this).parents(".widget-title");
                if (b.hasClass("click")) b.removeClass("click"); else b.addClass("click");
                a(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
            });
        },
        sidebarMapSorting: function(c) {
            a(".filter-sortby a").click(function(c) {
                if (!a(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = a(this).attr("href");
                    b.sidebarAjaxClick();
                    var d = a(this).text();
                    a(".filter-sortby > button span").text(d);
                    a(".filter-sortby li.active").removeClass("active");
                    a(this).parent().addClass("active");
                }
                c.preventDefault();
            });
        },
        sidebarMapPaging: function() {
            a(".pagination-page a").click(function(c) {
                var d = a(this).attr("href").match(/page=\d+/g);
                if (d) {
                    Shopify.queryParams.page = parseInt(d[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var e = b.sidebarCreateUrl();
                        b.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, e, e);
                        b.sidebarGetContent(e);
                        a("body,html").animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                c.preventDefault();
            });
        },
        sidebarMapClearAll: function() {
            a(".refined-widgets a.clear-all").click(function(a) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                b.sidebarAjaxClick();
                a.preventDefault();
            });
        },
        sidebarMapClear: function() {
            a(".sidebar-tag").each(function() {
                var c = a(this);
                if (c.find("input:checked").length > 0) c.find(".clear").show().click(function(d) {
                    var e = [];
                    if (Shopify.queryParams.constraint) e = Shopify.queryParams.constraint.split("+");
                    c.find("input:checked").each(function() {
                        var b = a(this);
                        var c = b.val();
                        if (c) {
                            var d = e.indexOf(c);
                            if (d >= 0) e.splice(d, 1);
                        }
                    });
                    if (e.length) Shopify.queryParams.constraint = e.join("+"); else delete Shopify.queryParams.constraint;
                    b.sidebarAjaxClick();
                    d.preventDefault();
                });
            });
        },
        sidebarMapEvents: function() {
            b.sidebarMapTagEvents();
            b.sidebarMapCategories();
            b.sidebarMapView();
            b.sidebarMapShow();
            b.sidebarMapSorting();
        },
        reActivateSidebar: function() {
            a(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
            a(".sidebar-tag input:checked").attr("checked", false);
            var c = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (c && c[1]) a(".sidebar-links a[href='" + c[0] + "']").addClass("active");
            if (Shopify.queryParams.view) {
                a(".view-mode .active").removeClass("active");
                var d = Shopify.queryParams.view;
                if (d.indexOf("list") >= 0) {
                    a(".view-mode .list").addClass("active");
                    d = d.replace("list", "");
                } else a(".view-mode .grid").addClass("active");
                a(".filter-show > button span").text(d);
                a(".filter-show li.active").removeClass("active");
                a(".filter-show a[href='" + d + "']").parent().addClass("active");
            }
            b.initSortby();
        },
        initSortby: function() {
            if (Shopify.queryParams.sort_by) {
                var b = Shopify.queryParams.sort_by;
                var c = a(".filter-sortby a[href='" + b + "']").text();
                a(".filter-sortby > button span").text(c);
                a(".filter-sortby li.active").removeClass("active");
                a(".filter-sortby a[href='" + b + "']").parent().addClass("active");
            }
        },
        sidebarMapData: function(c) {
            var d = a(".col-main .products-grid");
            if (0 == d.length) d = a(".col-main .product-list");
            var e = a(c).find(".col-main .products-grid");
            if (0 == e.length) e = a(c).find(".col-main .product-list");
            if (e.length > 0 && e.hasClass("products-grid")) if (window.product_image_resize) e.find("img").fakecrop({
                fill: window.images_size.is_crop,
                widthSelector: ".products-grid .grid-item .product-image",
                ratioWrapper: window.images_size
            });
            d.replaceWith(e);
            if (b.checkNeedToConvertCurrency()) Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), ".col-main span.money", "money_format");
            if (a(".padding").length > 0) a(".padding").replaceWith(a(c).find(".padding")); else a(".block-row.col-main").append(a(c).find(".padding"));
            var f = a(".page-header");
            var g = a(c).find(".page-header");
            if (f.find("h2").text() != g.find("h2").text()) {
                f.find("h2").replaceWith(g.find("h2"));
                if (f.find(".rte").length) if (g.find(".rte").length) f.find(".rte").replaceWith(g.find(".rte")); else f.find(".rte").hide(); else if (g.find(".rte").length) f.find("h2").after(g.find(".rte"));
            }
            a(".refined-widgets").replaceWith(a(c).find(".refined-widgets"));
            a(".sidebar-block").replaceWith(a(c).find(".sidebar-block"));
        },
        sidebarCreateUrl: function(b) {
            var c = a.param(Shopify.queryParams).replace(/%2B/g, "+");
            if (b) if ("" != c) return b + "?" + c; else return b;
            return location.pathname + "?" + c;
        },
        sidebarAjaxClick: function(a) {
            delete Shopify.queryParams.page;
            var c = b.sidebarCreateUrl(a);
            b.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, c, c);
            b.sidebarGetContent(c);
        },
        sidebarGetContent: function(c) {
            a.ajax({
                type: "get",
                url: c,
                beforeSend: function() {
                    b.showLoading();
                },
                success: function(a) {
                    b.sidebarMapData(a);
                    b.sidebarMapPaging();
                    b.sidebarMapTagEvents();
                    b.sidebarInitToggle();
                    b.sidebarMapClear();
                    b.sidebarMapClearAll();
                    b.hideLoading();
                    b.initQuickView();
                    b.initAddToCart();
                    b.initWishlist();
                },
                error: function(c, d) {
                    b.hideLoading();
                    a(".loading-modal").hide();
                    a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                    b.showModal(".ajax-error-modal");
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            if (location.search.length) for (var a, b = 0, c = location.search.substr(1).split("&"); b < c.length; b++) {
                a = c[b].split("=");
                if (a.length > 1) Shopify.queryParams[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            }
        },
        initMobileSidebar: function() {
            a("footer").append("<a class='option-sidebar left' id='displayTextLeft' href='javascript:void(0)' title='Show Sidebar'><span>Show Sidebar</span></a>");
            a("#displayTextLeft").click(function(b) {
                b.preventDefault();
                if (a(".sidebar").is(":hidden")) {
                    a(".sidebar").fadeIn(800);
                    a("body,html").animate({
                        scrollTop: 400
                    }, 600);
                    a("#displayTextLeft").toggleClass("hidden-arrow-left");
                    a("#displayTextLeft").attr("title", "hide-sidebar");
                    a("#displayTextLeft").html("<span>Hide Sidebar</span>");
                } else {
                    a(".sidebar").fadeOut(800);
                    a("#displayTextLeft").removeClass("hidden-arrow-left");
                    a("#displayTextLeft").attr("title", "show-sidebar");
                    a("#displayTextLeft").html("<span>Show Sidebar</span>");
                }
            });
        },
        initSidebar: function() {
            if (a(".collection-sidebar").length > 0) {
                b.sidebarParams();
                b.initSortby();
                b.sidebarMapEvents();
                b.sidebarMapPaging();
                b.sidebarInitToggle();
                b.sidebarMapClear();
                b.sidebarMapClearAll();
            }
        },
        initMobileMenu: function() {
            if (a(".menu-block").is(":visible")) {
                a(".gf-menu-device-container ul.gf-menu li.dropdown").each(function() {
                    if (0 == a(this).find("> p.toogleClick").length) a(this).prepend('<p class="toogleClick">+</p>');
                });
                if (false == a(".menu-block").children().hasClass("gf-menu-device-wrapper")) a(".menu-block").children().addClass("gf-menu-device-wrapper");
                if (0 == a(".gf-menu-device-container").find("ul.gf-menu").size()) {
                    a(".gf-menu-device-container").append(a(".nav-bar .container").html());
                    a(".gf-menu-device-container .site-nav").addClass("gf-menu");
                    a(".gf-menu-device-container .site-nav").removeClass("nav");
                }
                a("p.toogleClick").click(function() {
                    if (a(this).hasClass("mobile-toggle-open")) {
                        a(this).next().next().hide();
                        a(this).removeClass("mobile-toggle-open");
                    } else {
                        a(this).next().next().show();
                        a(this).addClass("mobile-toggle-open");
                    }
                });
                a("p.toogleClick").show();
                a("div.gf-menu-toggle").hide();
                a(".nav-bar .container").hide();
                if (false == a("ul.gf-menu").hasClass("clicked")) {
                    a(".gf-menu").hide();
                    a(".gf-menu li.dropdown ul.site-nav-dropdown").hide();
                }
                a(".col-1 .inner ul.dropdown").parent().each(function() {
                    if (0 == a(this).find("> p.toogleClick").length) a(this).prepend('<p class="toogleClick">+</p>');
                });
                a(".cbp-spmenu span.icon-dropdown").remove();
                a("ul.gf-menu li.dropdown").each(function() {
                    if (0 == a(this).find("> p.toogleClick").length) a(this).prepend('<p class="toogleClick">+</p>');
                });
                a("p.toogleClick").click(function() {
                    if (a(this).hasClass("mobile-toggle-open")) {
                        a(this).next().next().hide();
                        a(this).removeClass("mobile-toggle-open");
                    } else {
                        a(this).next().next().show();
                        a(this).addClass("mobile-toggle-open");
                    }
                });
                a(".header-panel-bottom ul.customer-links").prependTo(a(".customer-area .dropdown-menu"));
            } else {
                a(".nav-bar .container").show();
                a(".gf-menu").hide();
                a(".customer-area ul.customer-links").appendTo(a(".header-panel-bottom")).after(a(".top-header"));
            }
            if (false == a(".menu-block").children().hasClass("gf-menu-device-wrapper")) a(".menu-block").children().addClass("resized");
        },
        initWishlist: function() {
            a(".grid-item button.wishlist").click(function(c) {
                c.preventDefault();
                var d = a(this).parent();
                var e = d.parents(".grid-item");
                a.ajax({
                    type: "POST",
                    url: "/contact",
                    data: d.serialize(),
                    beforeSend: function() {
                        b.showLoading();
                    },
                    success: function(c) {
                        b.hideLoading();
                        d.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var f = e.find(".product-title").text();
                        var g = e.find("a > img").attr("src");
                        a(".ajax-success-modal").find(".ajax-product-title").text(f);
                        a(".ajax-success-modal").find(".ajax-product-image").attr("src", g);
                        a(".ajax-success-modal").find(".btn-go-to-wishlist").show();
                        a(".ajax-success-modal").find(".btn-go-to-cart").hide();
                        b.showModal(".ajax-success-modal");
                    },
                    error: function(c, d) {
                        b.hideLoading();
                        a(".loading-modal").hide();
                        a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                        b.showModal(".ajax-error-modal");
                    }
                });
            });
        },
        initProductWishlist: function() {
            a(".product button.wishlist").click(function(c) {
                c.preventDefault();
                var d = a(this).parent();
                var e = d.parents(".grid-item");
                a.ajax({
                    type: "POST",
                    url: "/contact",
                    data: d.serialize(),
                    beforeSend: function() {
                        b.showLoading();
                    },
                    success: function(c) {
                        b.hideLoading();
                        d.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var e = a(".product-title h2").text();
                        var f = a("#product-featured-image").attr("src");
                        a(".ajax-success-modal").find(".ajax-product-title").text(e);
                        a(".ajax-success-modal").find(".ajax-product-image").attr("src", f);
                        a(".ajax-success-modal").find(".btn-go-to-wishlist").show();
                        a(".ajax-success-modal").find(".btn-go-to-cart").hide();
                        b.showModal(".ajax-success-modal");
                    },
                    error: function(c, d) {
                        b.hideLoading();
                        a(".loading-modal").hide();
                        a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                        b.showModal(".ajax-error-modal");
                    }
                });
            });
        },
        initRemoveWishlist: function() {
            a(".btn-remove-wishlist").click(function(c) {
                var d = a(this).parents("tr");
                var e = d.find(".tag-id").val();
                var f = jQuery("#remove-wishlist-form");
                f.find("input[name='contact[tags]']").val("x" + e);
                a.ajax({
                    type: "POST",
                    url: "/contact",
                    data: f.serialize(),
                    beforeSend: function() {
                        b.showLoading();
                    },
                    success: function(a) {
                        b.hideLoading();
                        d.fadeOut(1e3);
                    },
                    error: function(c, d) {
                        b.hideLoading();
                        a(".loading-modal").hide();
                        a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                        b.showModal(".ajax-error-modal");
                    }
                });
            });
        },
        initResizeImage: function() {
            if (window.product_image_resize) a(".products-grid .product-image img").fakecrop({
                fill: window.images_size.is_crop,
                widthSelector: ".products-grid .grid-item .product-image",
                ratioWrapper: window.images_size
            });
        },
        initInfiniteScrolling: function() {
            if (a(".infinite-scrolling").length > 0) a(".infinite-scrolling a").click(function(c) {
                c.preventDefault();
                if (!a(this).hasClass("disabled")) b.doInfiniteScrolling();
            });
        },
        doInfiniteScrolling: function() {
            var c = a(".block-row .products-grid");
            if (!c.length) c = a(".block-row .product-list");
            if (c) {
                var d = a(".infinite-scrolling a").first();
                a.ajax({
                    type: "GET",
                    url: d.attr("href"),
                    beforeSend: function() {
                        b.showLoading();
                        a(".loading-modal").show();
                    },
                    success: function(e) {
                        b.hideLoading();
                        var f = a(e).find(".block-row .products-grid");
                        if (!f.length) f = a(e).find(".block-row .product-list");
                        if (f.length) {
                            if (f.hasClass("products-grid")) if (window.product_image_resize) f.children().find("img").fakecrop({
                                fill: window.images_size.is_crop,
                                widthSelector: ".products-grid .grid-item .product-image",
                                ratioWrapper: window.images_size
                            });
                            c.append(f.children());
                            b.initQuickView();
                            b.initAddToCart();
                            b.initWishlist();
                            if (a(e).find(".infinite-scrolling").length > 0) d.attr("href", a(e).find(".infinite-scrolling a").attr("href")); else {
                                d.hide();
                                d.next().show();
                            }
                            if (a(".spr-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), 
                            window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        }
                    },
                    error: function(c, d) {
                        b.hideLoading();
                        a(".loading-modal").hide();
                        a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                        b.showModal(".ajax-error-modal");
                    },
                    dataType: "html"
                });
            }
        },
        closeEmailModalWindow: function() {
            if (a("#email-modal").length > 0 && a("#email-modal").is(":visible")) a("#email-modal .modal-window").fadeOut(600, function() {
                a("#email-modal .modal-overlay").fadeOut(600, function() {
                    a("#email-modal").hide();
                    a.cookie("emailSubcribeModal", "closed", {
                        expires: 1,
                        path: "/"
                    });
                });
            });
        },
        showModal: function(c) {
            a(c).fadeIn(500);
            b.ellaTimeout = setTimeout(function() {
                a(c).fadeOut(500);
            }, 5e3);
        },
        initToggleCollectionPanel: function() {
            if (a(".collection-sharing-btn").length > 0) a(".collection-sharing-btn").click(function() {
                a(".collection-sharing-panel").toggle();
                if (a(".collection-sharing-panel").is(":visible")) {
                    a(".collection-sharing-btn").addClass("btn-hover");
                    a(".collection-filter-panel").hide();
                    a(".collection-filter-btn").removeClass("btn-hover");
                } else a(".collection-sharing-btn").removeClass("btn-hover");
            });
            if (a(".collection-filter-btn").length > 0) {
                a(".collection-filter-btn").click(function() {
                    a(".collection-filter-panel").toggle();
                    if (a(".collection-filter-panel").is(":visible")) {
                        a(".collection-filter-btn").addClass("btn-hover");
                        a(".collection-sharing-panel").hide();
                        a(".collection-sharing-btn").removeClass("btn-hover");
                    } else a(".collection-filter-btn").removeClass("btn-hover");
                });
                a(".collection-filter-panel select").change(function(b) {
                    window.location = a(this).find("option:selected").val();
                });
            }
        },
        checkItemsInDropdownCart: function() {
            if (a("#dropdown-cart .mini-products-list").children().length > 0) {
                a("#dropdown-cart .no-items").hide();
                a("#dropdown-cart .has-items").show();
            } else {
                a("#dropdown-cart .has-items").hide();
                a("#dropdown-cart .no-items").show();
            }
        },
        initModal: function() {
            a(".continue-shopping").click(function() {
                clearTimeout(b.ellaTimeout);
                a(".ajax-success-modal").fadeOut(500);
            });
            a(".close-modal, .overlay").click(function() {
                clearTimeout(b.ellaTimeout);
                a(".ajax-success-modal").fadeOut(500);
            });
        },
        initDropDownCart: function() {
            if ("click" == window.dropdowncart_type) a("#cartToggle").click(function() {
                if (a("#dropdown-cart").is(":visible")) a("#dropdown-cart").slideUp("fast"); else a("#dropdown-cart").slideDown("fast");
            }); else if (!("ontouchstart" in document)) {
                a("#cartToggle").hover(function() {
                    if (!a("#dropdown-cart").is(":visible")) a("#dropdown-cart").slideDown("fast");
                });
                a(".wrapper-top-cart").mouseleave(function() {
                    a("#dropdown-cart").slideUp("fast");
                });
            } else a("#cartToggle").click(function() {
                if (a("#dropdown-cart").is(":visible")) a("#dropdown-cart").slideUp("fast"); else a("#dropdown-cart").slideDown("fast");
            });
            b.checkItemsInDropdownCart();
            a("#dropdown-cart .no-items a").click(function() {
                a("#dropdown-cart").slideUp("fast");
            });
            a("#dropdown-cart .btn-remove").click(function(c) {
                c.preventDefault();
                var d = a(this).parents(".item").attr("id");
                d = d.match(/\d+/g);
                Shopify.removeItem(d, function(a) {
                    b.doUpdateDropdownCart(a);
                });
            });
        },
        closeDropdownCart: function() {
            if (a("#dropdown-cart").is(":visible")) a("#dropdown-cart").slideUp("fast");
        },
        initDropdownSearch: function() {
            a(".nav-search .icon-search").click(function() {
                if (a(".header-bottom.on .search-bar").is(":visible")) a(".header-bottom.on .search-bar").slideUp("fast"); else a(".header-bottom.on .search-bar").slideDown("fast");
            });
        },
        closeDropdownSearch: function() {
            if (a(".header-bottom.on .search-bar").is(":visible")) a(".header-bottom.on .search-bar").slideUp("fast");
        },
        initProductMoreview: function() {
            if (a(".more-view-wrapper-owlslider").length > 0) this.initOwlMoreview(); else if (a(".more-view-wrapper-jcarousel").length > 0) this.initJcarouselMoreview();
        },
        initOwlMoreview: function() {
            a(".more-view-wrapper-owlslider ul").owlCarousel({
                navigation: true,
                items: 5,
                itemsDesktop: [ 1199, 4 ],
                itemsDesktopSmall: [ 979, 3 ],
                itemsTablet: [ 768, 3 ],
                itemsTabletSmall: [ 540, 3 ],
                itemsMobile: [ 360, 3 ]
            }).css("visibility", "visible");
        },
        initJcarouselMoreview: function() {
            a(".more-view-wrapper-jcarousel ul").jcarousel({
                vertical: true
            }).css("visibility", "visible");
            a(".product-img-box").addClass("has-jcarousel");
            a(".more-view-wrapper").css("visibility", "visible");
        },
        initCloudzoom: function() {
            if (a("#product-featured-image").length > 0) if (a(".visible-phone").is(":visible")) {
                a("#product-featured-image").elevateZoom({
                    gallery: "more-view-carousel",
                    cursor: "pointer",
                    galleryActiveClass: "active",
                    imageCrossfade: false,
                    scrollZoom: false,
                    onImageSwapComplete: function() {
                        a(".zoomWrapper div").hide();
                    },
                    loadingIcon: window.loading_url
                });
                a("#product-featured-image").bind("click", function(a) {
                    return false;
                });
            } else {
                a("#product-featured-image").elevateZoom({
                    gallery: "more-view-carousel",
                    cursor: "pointer",
                    galleryActiveClass: "active",
                    imageCrossfade: true,
                    scrollZoom: true,
                    onImageSwapComplete: function() {
                        a(".zoomWrapper div").hide();
                    },
                    loadingIcon: window.loading_url
                });
                a("#product-featured-image").bind("click", function(b) {
                    var c = a("#product-featured-image").data("elevateZoom");
                    a.fancybox(c.getGalleryList());
                    return false;
                });
            }
        },
        initScrollTop: function() {
            a("#back-top").click(function() {
                a("body,html").animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        },
        initProductAddToCart: function() {
            if (a("#product-add-to-cart").length > 0) a("#product-add-to-cart").click(function(c) {
                c.preventDefault();
                if ("disabled" != a(this).attr("disabled")) if (!window.ajax_cart) a(this).closest("form").submit(); else {
                    var d = a("#add-to-cart-form select[name=id]").val();
                    if (!d) d = a("#add-to-cart-form input[name=id]").val();
                    var e = a("#add-to-cart-form input[name=quantity]").val();
                    if (!e) e = 1;
                    var f = a(".product-title h2").text();
                    var g = a("#product-featured-image").attr("src");
                    b.doAjaxAddToCart(d, e, f, g);
                }
                return false;
            });
        },
        initAddToCart: function() {
            if (a(".add-to-cart-btn").length > 0) a(".add-to-cart-btn").click(function(c) {
                c.preventDefault();
                if ("disabled" != a(this).attr("disabled")) {
                    var d = a(this).parents(".product-item");
                    var e = a(d).attr("id");
                    e = e.match(/\d+/g);
                    if (!window.ajax_cart) a("#product-actions-" + e).submit(); else {
                        var f = a("#product-actions-" + e + " select[name=id]").val();
                        if (!f) f = a("#product-actions-" + e + " input[name=id]").val();
                        var g = a("#product-actions-" + e + " input[name=quantity]").val();
                        if (!g) g = 1;
                        var h = a(d).find(".product-title").text();
                        var i = a(d).find(".product-grid-image img").attr("src");
                        b.doAjaxAddToCart(f, g, h, i);
                    }
                }
                return false;
            });
        },
        showLoading: function() {
            a(".loading-modal").show();
        },
        hideLoading: function() {
            a(".loading-modal").hide();
        },
        doAjaxAddToCart: function(c, d, e, f) {
            a.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + d + "&id=" + c,
                dataType: "json",
                beforeSend: function() {
                    b.showLoading();
                },
                success: function(c) {
                    b.hideLoading();
                    a(".ajax-success-modal").find(".ajax-product-title").text(e);
                    a(".ajax-success-modal").find(".ajax-product-image").attr("src", f);
                    a(".ajax-success-modal").find(".btn-go-to-wishlist").hide();
                    a(".ajax-success-modal").find(".btn-go-to-cart").show();
                    b.showModal(".ajax-success-modal");
                    b.updateDropdownCart();
                },
                error: function(c, d) {
                    b.hideLoading();
                    a(".ajax-error-message").text(a.parseJSON(c.responseText).description);
                    b.showModal(".ajax-error-modal");
                }
            });
        },
        initQuickView: function() {
            a(".quickview-button a").click(function() {
                var c = a(this).attr("id");
                Shopify.getProduct(c, function(c) {
                    var d = a("#quickview-template").html();
                    a(".quick-view").html(d);
                    var e = a(".quick-view");
                    e.find(".product-title a").text(c.title);
                    e.find(".product-title a").attr("href", c.url);
                    if (e.find(".product-vendor span").length > 0) e.find(".product-vendor span").text(c.vendor);
                    if (e.find(".product-type span").length > 0) e.find(".product-type span").text(c.type);
                    if (e.find(".product-inventory span").length > 0) {
                        var f = c.variants[0].inventory_quantity;
                        if (f > 0) if (null != c.variants[0].inventory_management) e.find(".product-inventory span").text(f + " in stock"); else e.find(".product-inventory span").text("Many in stock"); else e.find(".product-inventory span").text("Out of stock");
                    }
                    if (c.description.indexOf("[countdown]") > 0) {
                        var g = c.description.match(/\[countdown\](.*)\[\/countdown\]/);
                        if (g && g.length > 0) {
                            e.find(".countdown").show();
                            e.find(".quickview-clock").countdown(g[1], function(b) {
                                a(this).html(b.strftime("%Dd %H:%M:%S"));
                            });
                        }
                    }
                    if (e.find(".product-description").length > 0) {
                        var h = c.description.replace(/(<([^>]+)>)/gi, "");
                        var h = h.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
                        h = h.split(" ").splice(0, 20).join(" ") + "...";
                        e.find(".product-description").text(h);
                    } else e.find(".product-description").remove();
                    e.find(".price").html(Shopify.formatMoney(c.price, window.money_format));
                    e.find(".product-item").attr("id", "product-" + c.id);
                    e.find(".variants").attr("id", "product-actions-" + c.id);
                    e.find(".variants select").attr("id", "product-select-" + c.id);
                    if (c.compare_at_price > c.price) {
                        e.find(".compare-price").html(Shopify.formatMoney(c.compare_at_price_max, window.money_format)).show();
                        e.find(".price").addClass("on-sale");
                    } else {
                        e.find(".compare-price").html("");
                        e.find(".price").removeClass("on-sale");
                    }
                    if (!c.available) {
                        e.find("select, input, .total-price, .dec, .inc, .variants label").remove();
                        e.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                    } else {
                        e.find(".total-price span").html(Shopify.formatMoney(c.price, window.money_format));
                        if (window.use_color_swatch) b.createQuickViewVariantsSwatch(c, e); else b.createQuickViewVariants(c, e);
                    }
                    e.find(".button").on("click", function() {
                        var c = e.find(".quantity").val(), d = 1;
                        if ("+" == a(this).text()) d = parseInt(c) + 1; else if (c > 1) d = parseInt(c) - 1;
                        e.find(".quantity").val(d);
                        if (e.find(".total-price").length > 0) b.updatePricingQuickview();
                    });
                    if (window.show_multiple_currencies) Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format");
                    b.loadQuickViewSlider(c, e);
                    b.initQuickviewAddToCart();
                    a(".quick-view").fadeIn(500);
                    if (a(".quick-view .total-price").length > 0) a(".quick-view input[name=quantity]").on("change", b.updatePricingQuickview);
                });
                return false;
            });
            a(".quick-view .overlay, .close-window").live("click", function() {
                b.closeQuickViewPopup();
                return false;
            });
        },
        updatePricingQuickview: function() {
            var b = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var c = a(".quick-view .price").text().match(b);
            if (!c) {
                b = /([0-9]+[.|,][0-9]+)/g;
                c = a(".quick-view .price").text().match(b);
            }
            if (c) {
                var d = c[0];
                var e = d.replace(/[.|,]/g, "");
                var f = parseInt(a(".quick-view input[name=quantity]").val());
                var g = e * f;
                var h = Shopify.formatMoney(g, window.money_format);
                h = h.match(b)[0];
                var i = new RegExp(d, "g");
                var j = a(".quick-view .price").html().replace(i, h);
                a(".quick-view .total-price span").html(j);
            }
        },
        initQuickviewAddToCart: function() {
            if (a(".quick-view .add-to-cart-btn").length > 0) a(".quick-view .add-to-cart-btn").click(function() {
                var c = a(".quick-view select[name=id]").val();
                if (!c) c = a(".quick-view input[name=id]").val();
                var d = a(".quick-view input[name=quantity]").val();
                if (!d) d = 1;
                var e = a(".quick-view .product-title a").text();
                var f = a(".quick-view .quickview-featured-image img").attr("src");
                b.doAjaxAddToCart(c, d, e, f);
                b.closeQuickViewPopup();
            });
        },
        updateDropdownCart: function() {
            Shopify.getCart(function(a) {
                b.doUpdateDropdownCart(a);
            });
        },
        doUpdateDropdownCart: function(c) {
            var d = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
            a("#cartCount").text(c.item_count);
            a("#dropdown-cart .summary .price").html(Shopify.formatMoney(c.total_price, window.money_format));
            a("#dropdown-cart .mini-products-list").html("");
            if (c.item_count > 0) {
                for (var e = 0; e < c.items.length; e++) {
                    var f = d;
                    f = f.replace(/\{ID\}/g, c.items[e].id);
                    f = f.replace(/\{URL\}/g, c.items[e].url);
                    f = f.replace(/\{TITLE\}/g, c.items[e].title);
                    f = f.replace(/\{QUANTITY\}/g, c.items[e].quantity);
                    f = f.replace(/\{IMAGE\}/g, Shopify.resizeImage(c.items[e].image, "small"));
                    f = f.replace(/\{PRICE\}/g, Shopify.formatMoney(c.items[e].price, window.money_format));
                    a("#dropdown-cart .mini-products-list").append(f);
                }
                a("#dropdown-cart .btn-remove").click(function(c) {
                    c.preventDefault();
                    var d = a(this).parents(".item").attr("id");
                    d = d.match(/\d+/g);
                    Shopify.removeItem(d, function(a) {
                        b.doUpdateDropdownCart(a);
                    });
                });
                if (b.checkNeedToConvertCurrency()) Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "#dropdown-cart span.money", "money_format");
            }
            b.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function(c, d) {
            var e = Shopify.resizeImage(c.featured_image, "grande");
            d.find(".quickview-featured-image").append('<a href="' + c.url + '"><img src="' + e + '" title="' + c.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            if (c.images.length > 2) {
                var f = d.find(".more-view-wrapper ul");
                for (i in c.images) {
                    var g = Shopify.resizeImage(c.images[i], "grande");
                    var h = Shopify.resizeImage(c.images[i], "compact");
                    var j = '<li><a href="javascript:void(0)" data-image="' + g + '"><img src="' + h + '"  /></a></li>';
                    f.append(j);
                }
                f.find("a").click(function() {
                    var b = d.find(".quickview-featured-image img");
                    var c = d.find(".quickview-featured-image div");
                    if (b.attr("src") != a(this).attr("data-image")) {
                        b.attr("src", a(this).attr("data-image"));
                        c.show();
                        b.load(function(b) {
                            c.hide();
                            a(this).unbind("load");
                            c.hide();
                        });
                    }
                });
                if (f.hasClass("quickview-more-views-owlslider")) b.initQuickViewCarousel(f); else b.initQuickViewVerticalMoreview(f);
            } else {
                d.find(".quickview-more-views").remove();
                d.find(".quickview-more-view-wrapper-jcarousel").remove();
            }
        },
        initQuickViewCarousel: function(a) {
            if (a) a.owlCarousel({
                navigation: true,
                items: 5,
                itemsDesktop: [ 1199, 4 ],
                itemsDesktopSmall: [ 979, 3 ],
                itemsTablet: [ 768, 3 ],
                itemsTabletSmall: [ 540, 3 ],
                itemsMobile: [ 360, 3 ]
            }).css("visibility", "visible");
        },
        initQuickViewVerticalMoreview: function(b) {
            if (b) {
                b.jcarousel({
                    vertical: true
                });
                a(".product-img-box").addClass("has-jcarousel");
                a(".more-view-wrapper").css("visibility", "visible");
            }
        },
        convertToSlug: function(a) {
            return a.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
        },
        createQuickViewVariantsSwatch: function(b, c) {
            if (b.variants.length > 1) {
                for (var d = 0; d < b.variants.length; d++) {
                    var e = b.variants[d];
                    var f = '<option value="' + e.id + '">' + e.title + "</option>";
                    c.find("form.variants > select").append(f);
                }
                new Shopify.OptionSelectors("product-select-" + b.id, {
                    product: b,
                    onVariantSelected: selectCallbackQuickview
                });
                var g = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
                var h = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
                var i = "";
                for (var d = 0; d < b.options.length; d++) {
                    i += '<div class="swatch clearfix" data-option-index="' + d + '">';
                    i += '<div class="header">' + b.options[d].name + "</div>";
                    var j = false;
                    if (/Color|Colour/i.test(b.options[d].name)) j = true;
                    var k = new Array();
                    for (var l = 0; l < b.variants.length; l++) {
                        var e = b.variants[l];
                        var m = e.options[d];
                        var n = this.convertToSlug(m);
                        var o = "swatch-" + d + "-" + n;
                        if (k.indexOf(m) < 0) {
                            i += '<div data-value="' + m + '" class="swatch-element ' + (j ? "color" : "") + n + (e.available ? " available " : " soldout ") + '">';
                            if (j) i += '<div class="tooltip">' + m + "</div>";
                            i += '<input id="' + o + '" type="radio" name="option-' + d + '" value="' + m + '" ' + (0 == l ? " checked " : "") + (e.available ? "" : " disabled") + " />";
                            if (j) i += '<label for="' + o + '" style="background-color: ' + n + "; background-image: url(" + g + n + '.png)"><img class="crossed-out" src="' + h + 'soldout.png" /></label>'; else i += '<label for="' + o + '">' + m + '<img class="crossed-out" src="' + h + 'soldout.png" /></label>';
                            i += "</div>";
                            if (e.available) a('.quick-view .swatch[data-option-index="' + d + '"] .' + n).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled");
                            k.push(m);
                        }
                    }
                    i += "</div>";
                }
                c.find("form.variants > select").after(i);
                c.find(".swatch :radio").change(function() {
                    var b = a(this).closest(".swatch").attr("data-option-index");
                    var c = a(this).val();
                    a(this).closest("form").find(".single-option-selector").eq(b).val(c).trigger("change");
                });
                if (b.available) {
                    Shopify.optionsMap = {};
                    Shopify.linkOptionSelectors(b);
                }
            } else {
                c.find("form.variants > select").remove();
                var p = '<input type="hidden" name="id" value="' + b.variants[0].id + '">';
                c.find("form.variants").append(p);
            }
        },
        createQuickViewVariants: function(b, c) {
            if (b.variants.length > 1) {
                for (var d = 0; d < b.variants.length; d++) {
                    var e = b.variants[d];
                    var f = '<option value="' + e.id + '">' + e.title + "</option>";
                    c.find("form.variants > select").append(f);
                }
                new Shopify.OptionSelectors("product-select-" + b.id, {
                    product: b,
                    onVariantSelected: selectCallbackQuickview
                });
                a(".quick-view .single-option-selector").selectize();
                a(".quick-view .selectize-input input").attr("disabled", "disabled");
                if (1 == b.options.length) a(".selector-wrapper:eq(0)").prepend("<label>" + b.options[0].name + "</label>");
                c.find("form.variants .selector-wrapper label").each(function(c, d) {
                    a(this).html(b.options[c].name);
                });
            } else {
                c.find("form.variants > select").remove();
                var g = '<input type="hidden" name="id" value="' + b.variants[0].id + '">';
                c.find("form.variants").append(g);
            }
        },
        closeQuickViewPopup: function() {
            a(".quick-view").fadeOut(500);
        }
    };
}(jQuery);